import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
    init($element) {
    },
    
    finalize($element) {
            
        const quote = $element.find('.quote-text').get()[0];
        const letters = quote.innerHTML;
        let letterArray = letters.split(' ');

        quote.innerHTML = '';

        (letterArray).forEach(element => {
            const word = document.createElement('p');
            word.innerHTML = element;

            quote.appendChild(word);
        });

        const wordArray = quote.children;
        const elements = wordArray;
        const tl = gsap.timeline();
        tl.to(elements, {
            stagger: .25,
            color: '#003c72',
            borderColor: '#003c72',
            duration: 1,
        })

        ScrollTrigger.create({
            trigger: elements,
            animation: tl,
            // markers: true,
            start: 'top center+=300px',
            end: 'top center',
            scrub: true,
          });
    },
}



// WEBPACK FOOTER //
// ./scripts/partials/general/popQuote.js